export default "__VITE_ASSET__mj5H$Lsr__"